/**
 * Проверка валидности email
 * @param {string} email - проверяемый email
 * @returns {boolean} - true если email валиден
 */
export const isValidEmail = (email) => {
  if (!email || email.trim() === "") return false;

  const emailRegex =
    /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
};

/**
 * Получение сообщения об ошибке для email
 * @param {string} email - проверяемый email
 * @returns {string|null} - сообщение об ошибке или null
 */
export const getEmailErrorMessage = (email) => {
  if (!email || email.trim() === "") {
    return null;
  }

  if (email.startsWith(".") || email.endsWith(".")) {
    return "Email не может начинаться или заканчиваться точкой";
  }

  if (email.startsWith("@") || email.endsWith("@")) {
    return "Email не может начинаться или заканчиваться символом '@'";
  }

  if (email.includes("@") && email.indexOf("@") !== email.lastIndexOf("@")) {
    return "Email не может содержать несколько символов '@'";
  }

  if (email.includes("..")) {
    return "Email не может содержать две точки подряд";
  }

  const localPart = email.split("@")[0];
  if (localPart && /[^a-zA-Z0-9._%+-]/.test(localPart)) {
    return "Локальная часть email содержит недопустимые символы";
  }

  if (!isValidEmail(email)) {
    return "Введите корректный email адрес (example@mail.ru)";
  }

  return null;
};
